import BaseModalController from "./base_modal_controller";


export default class extends BaseModalController {
  static values = {
    ...BaseModalController.values,
    priority: { type: Number, default: 10 },
    queueable: { type: Boolean, default: true },
    autoShow: { type: Boolean, default: true }
  }

  getShowDelay() {
    return 1000;
  }

  shouldShow() {
    const modalId = this.element.id;
    const localKey = `welcome_modal_${modalId}_dismissed`;
    const isDismissed = localStorage.getItem(localKey) === 'true';
    
    return !isDismissed;
  }

  onDismiss() {
    const modalId = this.element.id;
    const localKey = `welcome_modal_${modalId}_dismissed`;
    localStorage.setItem(localKey, 'true');

  }
}
